import React from 'react';
import ReportDrilldownPage from './ReportDrilldownPage';

const VehicleDrilldownReport = () => <ReportDrilldownPage type="vehicle" />;

export default VehicleDrilldownReport;
